// ======================================================================
// File: src/modules/ppe/pages/procurement/grn/list/grnColumns.js
// Module: PPE → Procurement → GRN
//
// Purpose:
// - Column definitions for GRN list table
// - Centralized configuration similar to indentColumns.js
// ======================================================================

import React from "react";
import { formatDate } from "../../../../../../utils/formatUtils";

const grnColumns = [
  {
    key: "grn_no",
    title: "GRN No",
  },

  {
  key: "grn_date",
  title: "Date",
  render: (row) => formatDate(row.grn_date),
},

  {
    key: "vendor_name",
    title: "Vendor",
    render: (row) => row.vendor_name || row.vendor_id || "-",
  },

  {
    key: "po_no",
    title: "PO No",
  },

  {
    key: "invoice_no",
    title: "Invoice No",
  },

  {
    key: "status",
    title: "Status",
    render: (row) => {
      let color = "#6b7280";

      switch (row.status) {
        case "DRAFT":
          color = "#6b7280";
          break;

        case "SUBMITTED":
          color = "#0284c7";
          break;

        case "APPROVED":
          color = "#16a34a";
          break;

        case "POSTED":
          color = "#7c3aed";
          break;

        case "CANCELLED":
          color = "#dc2626";
          break;

        default:
          color = "#6b7280";
      }

      return (
        <span
          style={{
            padding: "4px 10px",
            borderRadius: 12,
            fontSize: 12,
            fontWeight: 500,
            background: "#f3f4f6",
            color: color,
          }}
        >
          {row.status}
        </span>
      );
    },
  },

  {
    key: "actions",
    title: "Actions",
    render: (row, { navigate }) => {
      return (
        <div style={{ display: "flex", gap: 8 }}>
          <span
            style={{
              color: "#2563eb",
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(`/ppe/procurement/grn/${row.id}`)
            }
          >
            View
          </span>
        </div>
      );
    },
  },
];

export default grnColumns;
